export const DEFAULT_VISIBILITY = "true";
export const DEFAULT_NOTIFY = "true";
export const DEFAULT_VER = "2.1";
